<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_commission_rule") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2">
			<!-- Name and description -->
			<div class="flex wrap xs-12 p4">
				<div class="xs-12 md-6 md-pr2 mb4 md-mb0">
					<label for="name" class="lh125 mb1 fw7">{{ $t("rule_name") }}</label>
					<j-base-input-text
						name="name"
						id="name"
						v-model="form.name"
						:status="errors.first('name') ? 'error' : null"
						v-validate="'required'"
					/>
				</div>
				<div class="xs-12 md-6 md-pl2">
					<label class="lh125 mb1 fw7"
						>{{ $t("description") }}
						<span class="fs3 c6">({{ $t("optional") }})</span></label
					>
					<j-base-input-text v-model="form.description" />
				</div>
			</div>

			<!-- Start and End -->
			<!-- <div class="flex wrap xs-12 bt1 bc7--l4 p4">
        <div class="xs-12 mb4">
          <div class="fw7 lh125">{{$t("commission_effective_date")}}</div>
          <div class="c6 fs3 lh125">{{$t("commission_effective_date_explanation")}}</div>
        </div>
        <div class="xs-12 md-6 md-pr2 mb4 md-mb0">
          <label for="start_date" class="block lh125 fw4">{{$t("start_date")}} <span class="fs3 c6">(DD/MM/YYYY)</span></label>
          <j-base-input-text 
            placeholder="DD/MM/YYYY"
            name="start_date"
            id="start_date"
            v-validate="'date_format:DD/MM/YYYY|required'"
				    :data-vv-as="$t('date')" 
				    :status="errors.first('start_date') ? 'error' : null "
            v-model="form.startDate"/>
            <div class="fs3 cError mt1">{{errors.first('start_date')}}</div>
        </div>
        <div class="xs-12 md-6 md-pl2">
          <label for="end_date" class="block lh125 fw4">{{$t("end_date")}} <span class="fs3 c6">(DD/MM/YYYY)</span></label>
          <j-base-input-text 
            placeholder="DD/MM/YYYY"
            name="end_date"
            id="end_date"
            v-validate="'date_format:DD/MM/YYYY|required'"
				    :data-vv-as="$t('date')" 
				    :status="errors.first('end_date') ? 'error' : null "
            v-model="form.endDate"/>
            <div class="fs3 cError mt1">{{errors.first('end_date')}}</div>
        </div>
      </div> -->

			<!-- Product -->
			<div class="xs-12 p4 bt1 bc7--l4">
				<label for="product" class="lh125 mb1 fw7">{{ $t("product") }}</label>
				<core-select-product
					name="product"
					id="product"
					:status="errors.first('product') ? 'error' : null"
					v-validate="'required'"
					v-model="form.products"
				/>
			</div>

			<!-- Entities -->
			<div class="xs-12 p4 bt1 bc7--l4">
				<label for="entities" class="block lh125 fw7">{{ $t("users") }}</label>
				<span class="block mb1 fs3 c6 lh125">{{
					$t("select_users_explanation")
				}}</span>
				<core-select-internals
					name="entities"
					id="entities"
					:status="errors.first('entities') ? 'error' : null"
					v-validate="'required'"
					v-model="form.entities"
					:allowMultiselect="true"
				/>
			</div>

			<!-- Commission Rule -->
			<div class="xs-12 p4 bt1 bc7--l4">
				<label for="product" class="lh125 mb1 fw7">{{
					$t("commission_rule")
				}}</label>
				<core-commission-json-rule
					name="product"
					id="product"
					:status="errors.first('product') ? 'error' : null"
					v-validate="'required'"
					v-model="form.jsonRule"
				/>
			</div>
		</j-card>

		<!-- Buttons -->
		<div class="flex xs-between xs-12 mt4">
			<j-button :isLoading="isLoading" @click="createRule">
				{{ $t("create_rule") }}
			</j-button>
			<j-button
				type="bordered"
				:isDisabled="isLoading"
				@click="$router.push({ name: 'CommissionsList' })"
			>
				{{ $t("cancel") }}
			</j-button>
		</div>
	</core-layout-content>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseRadios from "@/components/JBaseRadios/"
import JButton from "@/components/JButton/"
import CoreSelectProduct from "@/modules/core/components/CoreSelectProduct"
import CoreSelectInternals from "@/modules/core/components/CoreSelectInternals"
import CrmIcon from "@/components/CrmIcon/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CoreCommissionJsonRule from "@/modules/core/components/CoreCommissionJsonRule.vue"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		JCard,
		JBaseInputText,
		JBaseRadios,
		JButton,
		CoreSelectProduct,
		CoreSelectInternals,
		CrmIcon,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreCommissionJsonRule
	},

	data: () => ({
		isLoading: false,

		form: {
			products: [],
			startDate: null,
			endDate: null,
			name: null,
			description: null,
			entities: [],
			jsonRule: `{ "*": [ {"var" : "totalPremium"}, 0.15 ]}` // TODO: hacking for testing
		}
	}),

	methods: {
		/**
		 * This method takes form payload and creates rule in database
		 */
		async createRule() {
			// TODO: validate
			// const isValid = await this.$validator.validate();
			// if (!isValid) return;

			// 1: First create rule itself
			this.isLoading = true
			const res = await api.createCommissionRule({
				input: {
					productId: get(this, "form.products[0].productId"),
					jsonRule: this.form.jsonRule,
					name: this.form.name,
					description: this.form.description
				}
			})

			// Handle error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			const ruleId = get(res, "data.createCommissionRule.createdStatus.id")

			// 2: Add all entities to the rule
			const entitiesRes = await Promise.all(
				this.form.entities.map(item =>
					api.addEntityToCommissionRule({
						id: ruleId,
						entityId: item.id
					})
				)
			)

			// Check errors
			// If there is any error, show to user that some entities weren't added
			// TODO: we should show what entities failed and weren't added
			// Show general error for now
			console.log({ entitiesRes })
			if (entitiesRes.find(batch => batch.errors)) {
				console.log("errr")
				this.$store.dispatch("showError", [this.$t("errors.general")])
			}

			this.isLoading = false

			// When success, redirect to list for now
			this.$router.push({
				name: "CommissionsList"
			})
		}
	}
}
</script>
